/** 统计页图表/表格空状态文案（统一口径） */
export const STATISTICS_EMPTY_CHART = '当前筛选暂无数据';
export const STATISTICS_EMPTY_CHART_GEO = '当前筛选暂无可用地理数据';
export const STATISTICS_EMPTY_CHART_COMPARE =
	'所选时间段内暂无对应维度数据；可添加对比段（如不同年份）查看多线对比';
export const STATISTICS_EMPTY_CHART_COMPARE_IRREGULAR_PERIOD =
	'当前下单区间不规范，请通过选期选择整年、整月、整季或快捷区间后再做对比段分析';
export const STATISTICS_EMPTY_CHART_COMPARE_MAP_YEAR =
	'所选年份暂无可用客户城市数据；请选择对比年份';
export const STATISTICS_EMPTY_CHART_COMPARE_MAP_RANGE = '所选对比区间暂无可用客户城市数据';

export const STATISTICS_EMPTY_TABLE_ORDERS = '当前阶段暂无订单';
export const STATISTICS_EMPTY_TABLE_GROUP = '当前筛选暂无汇总数据';

export const STATISTICS_EMPTY_OVERDUE = '当前暂无未付应收账款';
export const STATISTICS_EMPTY_OVERDUE_RANK = '当前暂无超期未付尾款';
export const STATISTICS_EMPTY_PIN = '当前筛选暂无数据，无法固定';

export const STATISTICS_EMPTY_DRILL_ORDERS = '当前筛选暂无订单';
